// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gk-0";